
<template>
  <div class="cashcreation">
    <div class="header-text"
         :style="{ width: ElementHeight }">
      <h1 class="header-title">礼品主数据定义-查看</h1>
      <div class="buttom-div">
        <el-button class="push-button"
                   icon="iconfont icon-fanhui"
                   @click="backHistory">返回</el-button>
      </div>
    </div>
    <div class="header-text1"></div>
    <div>
      <el-card shadow="never"
               class="card-center"
               style="margin-top: 10px">
        <!-- 表单 -->
        <div style="width: 100%; height: 50%; margin: 0 auto">
          <el-form size="small"
                   :label-position="labelPosition"
                   label-width="100px">
            <el-row :gutter="200">
              <el-col :span="12">
                <el-form-item label="礼品编号">
                  <el-input v-model="ruleForm.giftNo"
                            :disabled="true"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="礼品名称">
                  <el-input v-model="ruleForm.giftName"
                            :disabled='true'></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="礼品类型">
                  <el-select v-model="ruleForm.giftKind"
                             style="width: 100%"
                             :disabled="true">
                    <el-option v-for="item in options"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="单位">
                  <el-input v-model="ruleForm.giftUnit"
                              :disabled="true"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="备注">
                    <el-input type="textarea"
                              v-model="ruleForm.remark"
                              disabled="true"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="200">
              <el-col :span="12">
                <el-form-item >
                  <div style="margin-top: 10px">
                    颜色
                    <el-table size="mini"
                              :header-cell-style="{
                        'text-align': 'center',
                      }"
                              :cell-style="{ 'text-align': 'center' }"
                              :data="newApp"
                              border>
                      <el-table-column type="index"
                                       width="40">
                      </el-table-column>
                      <el-table-column prop="attrValue"
                                       label="颜色">
                      </el-table-column>
                    </el-table>
                  </div>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item >

                  <div style="margin-top: 10px">
                    尺码
                    <el-table size="mini"
                              :header-cell-style="{
                        'text-align': 'center',
                      }"
                              :cell-style="{ 'text-align': 'center' }"
                              :data="newArr"
                              border>
                      <el-table-column type="index"
                                       width="40">
                      </el-table-column>
                      <el-table-column prop="attrValue"
                                       label="尺码">
                      </el-table-column>
                    </el-table>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <el-form-item label="SKU">
                  <el-table size="mini"
                            :row-class-name="tableRowClassName"
                            :header-cell-style="{
                      background: '#FCFBF2',
                      'text-align': 'center',
                      color: '#6C6839',
                    }"
                            :cell-style="{ 'text-align': 'center' }"
                            :data="tGiftskuList"
                            border>
                    <el-table-column type="index"
                                     width="40"> </el-table-column>
                    <el-table-column prop="sku"
                                     label="礼品SKU">
                    </el-table-column>            
                    <el-table-column prop="colorName"
                                     label="颜色">
                    </el-table-column>
                    <el-table-column prop="sizeName"
                                     label="尺码">
                    </el-table-column>
                    <el-table-column prop="productSKU"
                                     label="POS-SKU">
                      <template slot-scope="scope">
                        <div style="text-decoration: underline; color: #76734f"
                             @click="handleGoods(scope.row)">{{ scope.row.productSKU }}</div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="accessoriesSize"
                                     label="配饰规格">
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-card>
    </div>
    <!-- 产品信息详情查看弹窗-->
    <div class="found">
      <el-dialog width="60%"
                 title="产品详细信息"
                 :visible.sync="foundFormVisible"
                 :close-on-click-modal="false">
        <el-form size="mini"
                 label-width="80px"
                 :model="formLabeladd"
                 ref="resberValidateForm"
                 style="margin-top:20px">
          <el-row :gutter="30">
            <el-col :span="12">
              <el-form-item label="SKU">
                <el-input v-model="formLabeladd.sku"
                          :disabled="true"
                          style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="产品编码">
                <el-input placeholder=""
                          v-model="formLabeladd.productCode"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="30">
            <el-col :span="12">
              <el-form-item label="SKU描述中文">
                <el-input v-model="formLabeladd.skudesc_CN"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="产品中文描述">
                <el-input placeholder=""
                          v-model="formLabeladd.productName_CN"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="30">
            <el-col :span="12">
              <el-form-item label="SKU描述英文">
                <el-input placeholder=""
                          v-model="formLabeladd.skudesc_EN"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="产品名称英文"
                            prop="otherReason">
                <el-input placeholder=""
                          v-model="formLabeladd.productName_EN"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="30">
            <el-col :span="12">
              <el-form-item label="SKU描述意大利"
                            prop="realChgDate">
                <el-input placeholder=""
                          v-model="formLabeladd.skudesc_IT"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="产品名称意大利"
                            prop="remark">
                <el-input v-model="formLabeladd.productName_IT"
                          :disabled="true"
                          style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="品牌编号"
                            prop="remark">
                <el-input v-model="formLabeladd.brandNo"
                          :disabled="true"
                          style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="产品描述"
                            prop="remark">
                <el-input v-model="formLabeladd.description"
                          :disabled="true"
                          style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="种类编号"
                            prop="remark">
                <el-input v-model="formLabeladd.familyID"
                          :disabled="true"
                          style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="类别编号"
                            prop="remark">
                <el-input v-model="formLabeladd.categoryID"
                          :disabled="true"
                          style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="类别"
                            prop="remark">
                <el-input v-model="formLabeladd.category_cn"
                          :disabled="true"
                          style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="款号编号"
                            prop="remark">
                <el-input v-model="formLabeladd.styleID"
                          :disabled="true"
                          style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="类别英文"
                            prop="remark">
                <el-input v-model="formLabeladd.category_en"
                          :disabled="true"
                          style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="款号附加位编号"
                            prop="remark">
                <el-input v-model="formLabeladd.styleAddnCode"
                          :disabled="true"
                          style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="产品线编号"
                            prop="remark">
                <el-input v-model="formLabeladd.lineID"
                          :disabled="true"
                          style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="主成份编号"
                            prop="remark">
                <el-input v-model="formLabeladd.mainCompID"
                          :disabled="true"
                          style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="成份"
                            prop="remark">
                <el-input v-model="formLabeladd.composition_cn"
                          :disabled="true"
                          style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="颜色编号"
                            prop="remark">
                <el-input v-model="formLabeladd.colorID"
                          :disabled="true"
                          style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="成份英文"
                            prop="remark">
                <el-input v-model="formLabeladd.composition_en"
                          :disabled="true"
                          style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="季号"
                            prop="remark">
                <el-input v-model="formLabeladd.seasonID"
                          :disabled="true"
                          style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="尺码模板编号"
                            prop="remark">
                <el-input v-model="formLabeladd.sizeTemplateID"
                          :disabled="true"
                          style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="附加信息编码"
                            prop="remark">
                <el-input v-model="formLabeladd.addnCode"
                          :disabled="true"
                          style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="模板名称"
                            prop="remark">
                <el-input v-model="formLabeladd.templateName_cn"
                          :disabled="true"
                          style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="图像文件名"
                            prop="remark">
                <el-input v-model="formLabeladd.imgFileName1"
                          :disabled="true"
                          style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="模板名称英文"
                            prop="remark">
                <el-input v-model="formLabeladd.templateName_en"
                          :disabled="true"
                          style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="图像文件名2"
                            prop="remark">
                <el-input v-model="formLabeladd.imgFileName2"
                          :disabled="true"
                          style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="设计师编号"
                            prop="remark">
                <el-input v-model="formLabeladd.designerID"
                          :disabled="true"
                          style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="大类"
                            prop="remark">
                <el-input v-model="formLabeladd.zdl"
                          :disabled="true"
                          style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="设计师姓名"
                            prop="remark">
                <el-input v-model="formLabeladd.designerName"
                          :disabled="true"
                          style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="细类"
                            prop="remark">
                <el-input v-model="formLabeladd.zxlbm"
                          :disabled="true"
                          style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="系列"
                            prop="remark">
                <el-input v-model="formLabeladd.zxl"
                          :disabled="true"
                          style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="组别"
                            prop="remark">
                <el-input v-model="formLabeladd.groupLvl"
                          :disabled="true"
                          style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="性别(产品)"
                            prop="remark">
                <el-input v-model="formLabeladd.zwldl"
                          :disabled="true"
                          style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="产地"
                            prop="remark">
                <el-input v-model="formLabeladd.wherl"
                          :disabled="true"
                          style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="货币ID"
                            prop="remark">
                <el-input v-model="formLabeladd.currencyID"
                          :disabled="true"
                          style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="状态"
                            prop="remark">
                <!-- <el-input v-model="formLabeladd.state"
                          :disabled="true"
                          style="width: 100%">
                          </el-input> -->
                <el-select v-model="formLabeladd.state"
                           style="width: 100%"
                           :disabled="true">
                  <el-option v-for="item in StateList"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="款色编码"
                            prop="remark">
                <el-input v-model="formLabeladd.styleColorCode"
                          :disabled="true"
                          style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="创建人员"
                            prop="createUserID">
                <el-input v-model="formLabeladd.createUserName"
                          :disabled="true"
                          style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="创建时间">

                <el-time-picker v-model="formLabeladd.createTime"
                                :disabled="true"
                                style="width:100%"
                                format='yyyy-mm-dd:hh:mm'>
                </el-time-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="修改人员"
                            prop="updateUserID">
                <el-input v-model="formLabeladd.updateUserName"
                          :disabled="true"
                          style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="修改时间"
                            prop="remark">
                <el-time-picker v-model="formLabeladd.updateTime"
                                :disabled="true"
                                style="width:100%"
                                format='yyyy-mm-dd:hh:mm'>
                </el-time-picker>
              </el-form-item>
            </el-col>

          </el-row>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { reserveGIfSeetApi, detailedCapi } from "@/api/Integralquery";
export default {
  name: "centre",
  data () {
    return {
      screenWidth: "",
      ElementHeight: "0px",
      foundFormVisible: false,
      lookVisible: false,
      labelPosition: "right",
      value: "",
      ruleForm: [], //查看input框
      //表格数据
      tableData: [],
      //颜色数据存放
      giftIDList: [],
      //颜色
      newApp: [],
      //尺码
      newArr: [],
      //sku数据存放
      tGiftskuList: [],
      //礼品类型
      Selectesd: '',
      //礼品类型
      options: [{
        value: 0,
        label: '成衣'
      }, {
        value: 1,
        label: '革履'
      }, {
        value: 2,
        label: '配饰'
      },
      {
        value: 3,
        label: '非公司商品'
      }],
      formLabeladd: {},
      StateList: [{
        value: 0,
        label: '有效'
      },
      {
        value: 1,
        label: '无效'
      }],
    };
  },
  created () {
    this.getData();

  },
  watch: {
    //窗口宽度变化
    screenWidth () {
      this.ElementHeight =
        document.querySelector(".cashcreation").offsetWidth + "px";
    },
  },
  mounted () {
    this.getELmentHeight()
  },
  methods: {
    getELmentHeight () {
      this.screenWidth = document.body.clientWidth;
      window.onresize = () => {
        return (() => {
          this.screenWidth = document.body.clientWidth;
        })();
      };
    },
    async getData () {
      //获取路由 query 里面的id
      await reserveGIfSeetApi({ giftID: this.$route.query.id }).then((res) => {
        this.ruleForm = res.data
        this.giftIDList = res.tGiftattrList
        // console.log(this.giftIDList);
        this.tGiftskuList = res.tGiftskuList
      });
      this.giftIDList.forEach((item) => {
        if (item.attrKind == 1) {
          this.newApp.push(item)
        }
        if (item.attrKind == 2) {
          this.newArr.push(item)
        }
      })
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName ({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    // 点击返回按钮  返回上一页面
    backHistory () {
      this.$router.go(-1); //返回上一层
    },
    async handleGoods (row) {
      await detailedCapi({ SKU: row.productSKU }).then((res) => {
        if (res.message == "success") {
          this.formLabeladd = res.data
        }
      })
      this.foundFormVisible = true
    }

  },
};
</script>
<style lang="scss" scoped>
.header-text {
  position: fixed;
  z-index: 88;
  margin-top: -1.25rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  background-color: #f3f5f7;
  height: 4.5rem;
  color: #76734f;
  padding-bottom: 5px;
}
.card-pagination {
  height: 50px;
}

// input框的圆角取消
/deep/input {
  border-radius: 0 !important;
}
.header {
  .el-button {
    border-color: #e6e0af;
    border-radius: 7px;
    color: #a19b59;
  }
}
// 按钮边框去掉，文字颜色和加粗

::v-deep {
  // 表格隔行变色
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }
  .found {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 0 50px 0 50px;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
}
.cashcreation {
  margin-bottom: 100px;
}
.header-text1 {
  height: 3.5rem;
}
.buttom-div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
  height: 50px;
  // margin-right: 15px;
}
.push-button {
  width: 100px;
  color: #a19b59;
}
.header-title {
  min-width: 250px;
  line-height: 50px;
  height: 50px;
}
</style>
